module.exports = __webpack_public_path__ + "img/lvzhou.464abfb0.png";